import { Component, NgZone } from '@angular/core';
import { IonicPage, NavController, LoadingController, NavParams, AlertController, ToastController, ModalController, ModalOptions, Modal } from 'ionic-angular';
import { Sadhona } from '../../providers/sadhona'
import { CommentPage } from '../comment/comment'

@IonicPage()
@Component({
  selector: 'page-view-sadhana',
  templateUrl: 'view-sadhana.html',
})
export class ViewSadhanaPage {
  dayArray: any = []
  sadhonaDataArray: any
  myDate: any = new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
  // myDate:any= new Date('YYYY-MM')
  nofday: number;
  loading: any
  isSubmitted = false
  submittedsqno: number
  isapproved = false;
  constructor(public navCtrl: NavController, private zone: NgZone, public alertCtrl: AlertController,
    public navParams: NavParams, private sadhona: Sadhona, public loadingCtrl: LoadingController, private toastCtrl: ToastController,
    private modal: ModalController) {

  }
  ionViewDidLoad() {
    // init wait loader
    this.myDate = new Date().toJSON().split('T')[0];
    this.getSadhonaSheet()
  }

  getMonthDate() {
    this.dayArray = []
    for (let i = 1; i <= this.nofday; i++) { // n is array.length

      this.dayArray.push({ day: i })
    }
  }

  getSadhonaSheet() {
    this.presentLoadingDefault('Loading your records ')
    let data = this.myDate.split('-')
    let year = data[0]
    let month = data[1]
    this.nofday = this.daysInMonth(month, year)
    let fromdate = year + '-' + month + '-01'
    let todate = year + '-' + month + '-' + this.nofday
    this.getMonthDate()
    this.sadhona.getSadhanaSheet(fromdate, todate).subscribe(
      res => {
        this.getSubmittedSadhana()
        this.zone.run(() => {
          this.sadhonaDataArray = res['data']
          this.sadhonaDataArray.map(titem => {
            console.log(titem)
            if (titem.databasename == "delayinentering") {
              titem.item.map(sitem => {
                if (sitem.hasOwnProperty('item') && sitem.item > 8) {
                  sitem.color = 'red'
                } else if (sitem.hasOwnProperty('item') && sitem.item > 3 && sitem.item < 8) {
                  sitem.color = 'orange'
                } else if (sitem.hasOwnProperty('item')) {
                  sitem.color = 'green'
                } else {
                  sitem.color = ''
                }
              })
            } else {
              titem.item.map(sitem => {
                sitem.color = ''
              })
            }
          })
        });
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();

  }

  convertText(value) {
    if (typeof (value) === "boolean" && value == true) {
      return 'checkbox-outline'
    } else if (typeof (value) === "boolean" && value == false) {
      return ''
    } else {
      return value
    }
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  presentLoadingDefault(message) {
    let loading = this.loadingCtrl.create({
      content: message
    });

    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 2000);
  }

  SubmitSadhana() {
    const myModalOptions: ModalOptions = {
      enableBackdropDismiss: false
    };

    const myModal: Modal = this.modal.create('CommentPage', { data: this.myDate, type: 'Submit' }, myModalOptions);

    myModal.present();

    myModal.onDidDismiss((data) => {
      if (data.success) {
        this.submitSadhanaData(data.comment)
      }
    });
  }

  submitSadhanaData(comment) {
    let data = this.myDate.split('-')
    let year = data[0]
    let month = data[1]
    let submitData = { year: year, month: month, comment: comment }
    this.sadhona.noofSadhanaByMonth(year, month).subscribe((res: any) => {
      console.log(res);
      if (res['success']) {
        if (Number(res.data[0].sdays) !== this.nofday) {
          let alert = this.alertCtrl.create({
            title: 'Confirm Submit',
            message: 'You have not entered sadhana for all days in this month.Are you sure to submit?',
            buttons: [
              {
                text: 'No',
                role: 'cancel',
                handler: () => {

                }
              },
              {
                text: 'Yes',
                handler: () => {
                  this.sadhona.submitMonthSadhana(submitData).subscribe(res => {
                    this.submittedsqno = res['submitsq']
                    this.isSubmitted = true
                    this.presentToast('You have successfuly submitted the sadhana')
                  })
                }
              }
            ]
          });
          alert.present();
        } else {
          this.sadhona.submitMonthSadhana(submitData).subscribe(res => {
            this.submittedsqno = res['submitsq']
            this.isSubmitted = true
            this.presentToast('You have successfuly submitted the sadhana')
          })
        }
      }
    })

  }
  unsubmitSadhana(sequenceno) {

    let alert = this.alertCtrl.create({
      title: 'Confirm unsubmit',
      message: 'Do you want to unsubmit this month sadhana?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.unsubmitsadhanadata(sequenceno)
          }
        }
      ]
    });
    alert.present();
  }
  unsubmitsadhanadata(sqno) {
    let data = { sequenceno: sqno }
    this.sadhona.unsubmitMonthSadhana(data).subscribe(res => {
      if (!res['error']) {
        this.isSubmitted = false
        this.presentToast('You have successfuly unsubmitted the sadhana')
      } else {
        this.isSubmitted = true
        this.presentToast('Unsubmitting the sadhana not successfull')
      }

    })
  }
  getSubmittedSadhana() {
    let data = this.myDate.split('-')
    let year = data[0]
    let month = data[1]
    this.isSubmitted = false;
    this.isapproved = false;
    this.sadhona.submittedSadhanaByMonth(year, month).subscribe(
      res => {
        if (res['data'].length > 0) {
          this.isSubmitted = true
          this.submittedsqno = res['data'][0].sequencenumber
          if (res['data'][0].isapproved) {
            this.isapproved = true
          } else {
            this.isapproved = false
          }
        } else {
          this.isSubmitted = false
        }
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  sendEmail() {
    let data = this.myDate.split('-')
    let year = data[0]
    let month = data[1]
    let submitData = { year: year, month: month }
    this.sadhona.sendSadhanaEmail(submitData).subscribe(
      res => {
        this.presentToast('Email has been sent successfully')
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/view-sadhana/view-sadhana.ts